import React from 'react';
import SimpleReportSidebar from '../../PageComponents/SimpleReportSidebar';

/**
 * DeerFlow 侧边栏容器组件
 * 封装了 DeerFlow 报告侧边栏的所有渲染逻辑
 */
const DeerFlowSidebar = ({ deerFlowChatProps, style, s }) => {
    return (
        <>
            {/* 侧边栏 */}
            {deerFlowChatProps.sidebarOpen && (
                <div className={s['sidebar-container']} style={deerFlowChatProps.getSidebarStyle()}>
                    <SimpleReportSidebar
                        key={`sidebar-${deerFlowChatProps.sidebarRenderKey}-${deerFlowChatProps.reportDataRef.current.reportId || ''}`}
                        threadId={deerFlowChatProps.reportDataRef.current.threadId}
                        reportId={
                            // 如果用户选择了历史报告，使用历史报告的ID；否则使用当前正在生成的报告ID
                            deerFlowChatProps.activeReportCardId && deerFlowChatProps.activeReportCardId !== deerFlowChatProps.reportDataRef.current.reportId
                                ? deerFlowChatProps.activeReportCardId
                                : deerFlowChatProps.reportDataRef.current.reportId
                        }
                        uniqueReportId={
                            // 如果用户选择了历史报告，使用历史报告的ID；否则使用当前报告的uniqueReportId
                            deerFlowChatProps.activeReportCardId && deerFlowChatProps.activeReportCardId !== deerFlowChatProps.reportDataRef.current.reportId
                                ? deerFlowChatProps.activeReportCardId
                                : deerFlowChatProps.reportDataRef.current.uniqueReportId
                        }
                        activityData={
                            // 🔥 修复：当切换到不同报告时，清空数据让侧边栏重新加载，避免显示错误内容
                            deerFlowChatProps.activeReportCardId && deerFlowChatProps.activeReportCardId !== deerFlowChatProps.reportDataRef.current.reportId
                                ? null
                                : deerFlowChatProps.reportDataRef.current.activityData
                        }
                        reportContent={
                            // 🔥 修复：当切换到不同报告时，清空数据让侧边栏重新加载，避免显示错误内容
                            deerFlowChatProps.activeReportCardId && deerFlowChatProps.activeReportCardId !== deerFlowChatProps.reportDataRef.current.reportId
                                ? null
                                : deerFlowChatProps.reportDataRef.current.reportContent
                        }
                        data={
                            // 🔥 修复：当切换到不同报告时，清空数据让侧边栏重新加载，避免显示错误内容
                            deerFlowChatProps.activeReportCardId && deerFlowChatProps.activeReportCardId !== deerFlowChatProps.reportDataRef.current.reportId
                                ? { title: null, isFinal: null, timestamp: null }
                                : {
                                      title: deerFlowChatProps.reportDataRef.current.title,
                                      isFinal: deerFlowChatProps.reportDataRef.current.isFinal,
                                      timestamp: deerFlowChatProps.reportDataRef.current.timestamp
                                  }
                        }
                        onClose={deerFlowChatProps.handleSidebarClose}
                        forceRender={deerFlowChatProps.sidebarRenderKey > 0}
                        theme={style.themeColor}
                        themeColor={style.themeColor}
                        visible={deerFlowChatProps.sidebarOpen}
                        activeReportCardId={deerFlowChatProps.activeReportCardId}
                        activeGeneratingReportId={deerFlowChatProps.reportDataRef.current.reportId} // 传递真正正在生成的报告ID
                    />
                </div>
            )}
        </>
    );
};

export default DeerFlowSidebar;
